import { render, staticRenderFns } from "./TreeNodeFilesControl.global.vue?vue&type=template&id=bf2d8dc0&lang=pug&"
import script from "./TreeNodeFilesControl.global.vue?vue&type=script&lang=ts&"
export * from "./TreeNodeFilesControl.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports